import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchRefunds(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/finance/refunds/", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchRefund(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/finance/refunds/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editRefund(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/finance/refunds", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteRefund(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/finance/refunds", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    // updateRefundSalary(ctx, data) {
    //   return new Promise((resolve, reject) => {
    //     axiosIns
    //       .post("/refunds/salary", data)
    //       .then((response) => resolve(response))
    //       .catch((error) => reject(error));
    //   });
    // },
    deleteRefundItem(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/finance/refunds/item", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    updateRefundDocument(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/refunds/document", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteRefundDocument(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/refunds/document", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchReceipt(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/finance/receipts/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  }
};
